import { ItemText, Main } from 'components/ActionStyles/ActionStyles'
import AntdAvatar from 'components/Avatar'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import ResumeDownload from 'components/ResumeDownload'
import ResumePreview from 'components/ResumePreview'
import CallIcon from 'components/icons/CallIcon'
import MailIcon from 'components/icons/MailIcon'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import YellowStartIcon from 'components/icons/YellowStartIcon'
import { FooterFlex } from 'modules/Drives/DownloadAndUpload/DownloadCandidateDrawer/style'
import {
  DropBtn,
  DropDown,
  HeaderFlexATS,
  RatingText,
  RatingsDiv,
  StyledTab,
  TestDetailsFlexNew,
  ThreeDotsDiv,
  TopFlexNew,
  TopRightFlexATS,
  YellowStartSpan,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/style'
import {
  CollegeName,
  InfoSectionNew,
  StudentName,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer/style'
import CandidatesStatus from 'modules/Roles/ViewRole/CandidatesTable/CandidatesStatus'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { normalizeBooleanCondition } from '../../../../../../../utils/commonFunction'
import Questions from '../../../../Header/QuestionaireDashboard/IndividualPage/Partials/Question'
import Evaluation from './Evaluation'
import { ExtraPadding } from './Evaluation/style'
import RankingAlgorithm from './RankingAlgorithm'
import { Empty } from 'antd'

const { TabPane } = StyledTab

const CandidateViewDrawer = ({
  candidateDrawer,
  setCandidateDrawer,
  singleRoleData,
  singleCandidateRating,
  selectedRound,
  applicantMetrics,
  questionnaire = false,
  buttonText = 'Shortlist this Candidate',
  drawerStatus,
  onClickShortlist,
  questions,
}) => {

  const candidateDetails = useSelector(
    state => state?.corporate?.candidateDetails
  )

  const stdRankAlgoData = useSelector(
    state => state?.corporate?.studentRankingData
  )

  const evaluationData = useSelector(state => state?.corporate?.evaluationData)

  const tabList = [
    {
      key: 'RESUME',
      tabName: ' Resume',
      count: '',
    },
    // !normalizeBooleanCondition(candidateDetails?.isExpCandidate) &&
    // !questionnaire
    //   ? {
    //       key: 'RANKING',
    //       tabName: ' Rating Algorithm',
    //       count: '',
    //     }
    //   : null,
    !questionnaire
      ? {
          key: 'EVALUATION',
          tabName: ' Evaluation Result',
          count: '',
        }
      : null,
    questionnaire
      ? {
          key: 'QUESTIONNAIRE',
          tabName: 'Qualifying Questions',
          count: '',
        }
      : null,
  ]

  const items = [
    {
      key: 'download',
      label: (
        <ResumeDownload
          triggerButton={<ItemText weight={400}>Download Resume</ItemText>}
          studentDetails={candidateDetails}
          roleId={singleRoleData?.id}
        />
      ),
    },
  ]

  const [tabs, setTabs] = useState('RESUME')

  const onClose = () => {
    setCandidateDrawer(false)
  }

  const OnCurrentChange = value => {
    setTabs(value)
  }

  const content = () => {
    return (
      <>
        <HeaderFlexATS row spaceBetween centerVertically>
          <TopRightFlexATS row spaceBetween centerVertically>
            <TopFlexNew row centerVertically>
              <AntdAvatar
                size={90}
                src={candidateDetails?.profileUrl}
                IconName={candidateDetails?.firstName?.toUpperCase()?.charAt(0)}
              />
              <InfoSectionNew column center>
                <StudentName>
                  {candidateDetails?.firstName} {candidateDetails?.middelName}{' '}
                  {candidateDetails?.lastName}
                </StudentName>
                <CollegeName>
                  <MailIcon /> {candidateDetails?.admin?.email}
                </CollegeName>
                <CollegeName>
                  <CallIcon /> {candidateDetails?.admin?.country_code} -{' '}
                  {candidateDetails?.admin?.phone_number}
                </CollegeName>
              </InfoSectionNew>
            </TopFlexNew>
            {/* {!JSON.parse(candidateDetails?.isExpCandidate || 'false') &&
              !questionnaire && (
                <Flex row centerVertically>
                  <TestDetailsFlexNew column>
                    <RatingsDiv>
                      {Number(singleCandidateRating?.rating)?.toFixed(2)}
                      <YellowStartSpan>
                        <YellowStartIcon />
                      </YellowStartSpan>
                    </RatingsDiv>
                    <ExtraPadding />
                    <RatingText>RATING</RatingText>
                  </TestDetailsFlexNew>
                </Flex>
              )} */}
            {questionnaire ? (
              <Flex row centerVertically>
                <TestDetailsFlexNew column>
                  <CandidatesStatus status={drawerStatus} />
                </TestDetailsFlexNew>
              </Flex>
            ) : (
              ''
            )}
          </TopRightFlexATS>
          {tabs === 'RESUME' ? (
            <ThreeDotsDiv>
              <Main>
                <DropDown menu={{ items }} trigger={['click']}>
                  <DropBtn>
                    <VerticalThreeDots />
                  </DropBtn>
                </DropDown>
              </Main>
            </ThreeDotsDiv>
          ) : (
            ''
          )}
        </HeaderFlexATS>

        <div>
          <StyledTab onChange={OnCurrentChange} height={'unset'}>
            {tabList?.map(items => {
              return (
                <TabPane tab={items?.tabName} key={items?.key}>
                  {items?.key === 'RESUME' ? (
                    // Document view, like every other resume surface. The
                    // student record has no role-scoped isSystemResume flag, so
                    // the uploaded CV is read straight off the profile.
                    <ResumePreview
                      cvUrl={candidateDetails?.cvUrl}
                      studentId={candidateDetails?.id}
                      roleId={singleRoleData?.id}
                      candidateName={`${candidateDetails?.firstName || ''} ${
                        candidateDetails?.lastName || ''
                      }`.trim()}
                    />
                  ) : items?.key === 'RANKING' ? (
                    stdRankAlgoData != null && (
                      <RankingAlgorithm stdRankAlgoData={stdRankAlgoData} />
                    )
                  ) : items?.key === 'QUESTIONNAIRE' ? (
                    Object.keys(questions).length !== 0 ? (
                      <Questions questions={questions} />
                    ) : (
                      <Empty style={{ marginTop: '70px' }} description={'The qualifying questions were added to the job description after this student applied for the role'} />
                    )
                  ) : (
                    evaluationData &&
                    evaluationData?.length > 0 && (
                      <Evaluation
                        selectedRound={selectedRound}
                        applicantMetrics={applicantMetrics}
                        evaluationData={evaluationData}
                      />
                    )
                  )}
                </TabPane>
              )
            })}
          </StyledTab>
        </div>
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex flexEnd centerVertically>
        <Button.Secondary width="88px" text="Cancel" onClick={onClose} />
        <Button.Primary
          width="200px"
          text={buttonText}
          onClick={onClickShortlist}
        />
      </FooterFlex>
    )
  }
  return (
    <Drawer
      width="60%"
      placement="right"
      title={'Details of candidate'}
      visible={candidateDrawer}
      content={content()}
      onClose={onClose}
      footer={questionnaire && tabs == 'QUESTIONNAIRE' ? footer() : ''}
      closable
    />
  )
}

export default CandidateViewDrawer
